import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  Card,
  Dialog,
  CardContent,
  CardActions,
  CardMedia,
  CardActionArea,
  Typography,
  TextField,
  Box,
} from '@material-ui/core'

// import Card from 'src/components/sharedComponents/Card/Card';

import { Autocomplete } from '@material-ui/lab'
import CardTitle from '../../../components/sharedComponents/CardTitle'
import { styles, Button } from './styles'
import ReturnButton from '../ReturnButton'


const UsersControl = (props) => {
  const {
    mods,
    form,
    users,
    onChange,
    openForm,
    inputValue,
    onOpenForm,
    onCloseForm,
    onSubmitForm,
    onClickReturn,
    chooseUrl
  } = props
  const useStyles = makeStyles(styles)
  const classes = useStyles()

  return (
    <>
      <Dialog fullWidth maxWidth="sm" open={openForm} onClose={onCloseForm}>
        <form
          onSubmit={(event) => {
            onSubmitForm(event)
            onCloseForm()
          }}
        >
          <CardContent>
            <Autocomplete
              getOptionSelected={(option, anotherOption) =>
                option.value === anotherOption.value
              }
              getOptionLabel={(option) => `${option.label}`}
              value={form.valueInput}
              options={users}
              onChange={(event, newVal) => onChange(newVal, 'user')}
              renderInput={(params) => (
                <TextField {...params} label="Usuario" variant="outlined" />
              )}
              inputValue={inputValue}
              onInputChange={(event, newVal) => onChange(newVal, 'input')}
            />
          </CardContent>
          <CardActions>
            <Button onClick={onCloseForm} type="button" color="warning">
              Cerrar
            </Button>
            <Button type="submit">Asignar usuario</Button>
          </CardActions>
        </form>
      </Dialog>

      <CardTitle
        title="Panel de Usuarios"
        subTitle="Elige el usuario responsable de recibir los correos electronicos en cada unidad de negocio"
      />
      <ReturnButton label='Volver' onClick={onClickReturn}>Volver</ReturnButton>
      <Box className={classes.container}>
        {mods?.map((mod, index) => (
          <Card className={classes.root}>
            <CardActionArea onClick={() => onOpenForm(index)}>
              <CardMedia
                component="img"
                height="140"
                image={chooseUrl(mod.id_unidad)}
              />
              <CardContent>
                <Typography className={classes.title}>{mod.unidad}</Typography>
                <Typography className={classes.testResult}>
                  {mod.usuarioNombre}
                </Typography>
                <Typography className={classes.testResult}>
                  {mod.correo}
                </Typography>
              </CardContent>
            </CardActionArea>
            <CardActions>
              <Button width="fullWidth" onClick={() => onOpenForm(index)}>
                Asignar Usuario
              </Button>
            </CardActions>
          </Card>
        ))}
      </Box>
    </>
  )
}

export default UsersControl
